// Imports
import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash };
    if (savedPosition) return savedPosition;

    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      component: () => import("@/layouts/home/Index.vue"),
      children: [
        {
          path: "/",
          name: "Home",
          component: () => import("@/views/home/Index.vue")
        },
        {
          path: "/about-us",
          name: "About",
          component: () => import("@/views/about/Index.vue"),
          meta: { src: require("@/assets/about.jpg") }
        },
        {
          path: "/accounting-services",
          name: "Services",
          component: () => import("@/views/services/Index.vue"),
          meta: { src: require("@/assets/services.jpg") }
        },
        {
          path: "/pricing",
          name: "Pricing",
          component: () => import("@/views/pricing/Index.vue"),
          meta: { src: require("@/assets/services.jpg") }
        },
        {
          path: "/web-design-and-development",
          name: "Web Design and Development",
          component: () => import("@/views/webdesignanddevelopment/Index.vue"),
          meta: { src: require("@/assets/services.jpg") }
        },
        {
          path: "/it-services",
          name: "It Services",
          component: () => import("@/views/itservices/Index.vue"),
          meta: { src: require("@/assets/services.jpg") }
        },
        {
          path: "/offshore-software-development-srilanka",
          name: "Offshore Software Development Srilanka",
          component: () => import("@/views/softwaredev/Index.vue"),
          meta: { src: require("@/assets/services.jpg") }
        },
        {
          path: "/it-services",
          name: "it-services",
          component: () => import("@/views/it-services/Index.vue"),
          meta: { title: "IT Services", src: require("@/assets/services.jpg") },
          beforeEnter: () => {
            window.location.href =
              "https://kenwynconsultancy.com/kenwyn-systems";
          }
        },
        {
          path: "/promotions",
          name: "Promotion",
          component: () => import("@/views/promotion/Index.vue"),
          meta: { src: require("@/assets/about.jpg") }
        },
        {
          path: "/partners",
          name: "Partner",
          component: () => import("@/views/partner/Index.vue"),
          meta: { src: require("@/assets/partner.jpg") }
        },
        {
          path: "/career",
          name: "Career",
          component: () => import("@/views/career/Index.vue"),
          meta: { src: require("@/assets/partner.jpg") }
        },
        {
          path: "/contact-us",
          name: "Contact",
          component: () => import("@/views/contact-us/Index.vue"),
          meta: { src: require("@/assets/contact.jpg") }
        },
        {
          path: "/privacy-policy",
          name: "PrivacyPolicy",
          component: () => import("@/views/privacy-policy/Index.vue"),
          meta: { src: require("@/assets/contact.jpg") }
        },
        {
          path: "/book-keeping-monthly-25-transactions",
          redirect: "/pricing",
          name: "MAMS-STRIPE"

          // () =>
          // import(/* webpackChunkName: "home" */ "./views/pageView/home.vue"),
        },

        {
          path: "/book-keeping-monthly-50-transactions",
          redirect: "/pricing",
          name: "MAMS-STRIPE"

          // () =>
          // import(/* webpackChunkName: "home" */ "./views/pageView/home.vue"),
        },

        {
          path: "/book-keeping-monthly-100-transactions",
          redirect: "/pricing",
          name: "MAMS-STRIPE"

          // () =>
          // import(/* webpackChunkName: "home" */ "./views/pageView/home.vue"),
        },
        {
          path: "/accounting-promotion-2023",
          name: "Accounting Prmotion",
          component: () => import("@/views/accounting-promottion/Index.vue"),
          meta: { src: require("@/assets/flat-lay-business-concept.jpg") }
        },
        {
          path: "/netsuite-financial-consulting",
          name: "Netsuite Consulting",
          component: () => import("@/views/netsuite-consulting/Index.vue"),
          meta: { src: require("@/assets/flat-lay-business-concept.jpg") }
        },
        {
          path: "/netsuite-singapore-meetup-group",
          name: "Netsuite Meetup Group",
          component: () => import("@/views/netsuite-meetup-group/Index.vue"),
          meta: { src: require("@/assets/flat-lay-business-concept.jpg") }
        },
        {
          path: "/maid-agency-accounting-promotion",
          name: "Maid Agency Accounting Promotion",
          component: () => import("@/views/maid-agency-accounting-promotion/Index.vue"),
          meta: { src: require("@/assets/flat-lay-business-concept.jpg") }
        },
        {
          path: "/solutions",
          name: "Solutions",
          component: () => import("@/views/solutions/Index.vue"),
          meta: { src: require("@/assets/flat-lay-business-concept.jpg") }
        },
        {
          path: "/private-cloud-hosted-esign-system",
          name: "EsignSystem",
          component: () => import("@/views/esign-system/Index.vue"),
          meta: { src: require("@/assets/flat-lay-business-concept.jpg") }
        },
        {
          path: "/employment-agency-contract-generation-system",
          name: "EmploymentAgency",
          component: () => import("@/views/employment-agency/Index.vue"),
          meta: { src: require("@/assets/flat-lay-business-concept.jpg") }
        }
      ]
    }
  ]
});

export default router;
